export default __webpack_public_path__ + "static/media/ding.2cfe2fd4.mp3";